import { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";
import type { FontSize } from "../lib/storage";

const SIZE_CLASS: Record<FontSize, string> = {
  S: "reader-size-s",
  M: "reader-size-m",
  L: "reader-size-l",
};

interface ReaderProps {
  markdown: string;
  fontSize: FontSize;
}

/** Renders the assembled book.md as the centerpiece reading view (§7.2, §8). */
const Reader = forwardRef<HTMLDivElement, ReaderProps>(function Reader({ markdown, fontSize }, ref) {
  return (
    <div ref={ref} className={`reader-content mx-auto max-w-prose ${SIZE_CLASS[fontSize]}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>
        {markdown}
      </ReactMarkdown>
    </div>
  );
});

export default Reader;
